import React from 'react';
import { ManOutlined, WomanOutlined, UserOutlined } from '@ant-design/icons';

export const AGE_OPTIONS = [
    { label: '-17', value: 'under17' },
    { label: '18-21', value: '18-21' },
    { label: '22-25', value: '22-25' },
    { label: '26-35', value: '26-35' },
    { label: '36+', value: 'over36' },
];

export const GENDERS = [
    { label: 'Արական', value: 'male', icon: <ManOutlined /> },
    { label: 'Իգական', value: 'female', icon: <WomanOutlined /> },
];

export const SEARCH_GENDERS = [
    { label: 'Բոլորը', value: 'any', icon: <UserOutlined /> },
    ...GENDERS
];